<!-- Heading -->
<div #scrollable class="scroll-sidebar scroll-sidebar-auth opacity-block-double">
  <div class="container-fluid pb-6 my-7 my-lg-12">
    <div class="row-col-blocks row align-items-center justify-content-between">
      <div class="col-12 col-lg">
        <div class="text-center">
          <i-feather class="logo-big teleseller-logo invert effect3d" name="teleseller" width="133" height="88"></i-feather>
          <!--<img class="logo-big effect3d" src="/assets/images/logo-bot.svg" width="133" height="133" alt="">-->
        </div>
        <!--<h1 class="font-bold text-center">{{fellowdeskService.name}}</h1>-->
        <!-- Text -->
        <p class="text-center mb-6">Ваш цифровой менеджер 24/7 - продает, консультирует, помогает</p>
        <!-- Form -->
        <nz-alert nzType="info" nzMessage="Пожалуйста, введите свой логин и пароль."></nz-alert>

      </div>
      <div class="col-12 col-lg">
        <form [formGroup]="Form" (submit)="onSubmit()" class="mb-6">
          <div class="form-group">
            <label for="username" class="sr-only">Логин</label>
            <input
              type="text"
              formControlName="username"
              class="form-control form-control-lg justify-content-between"
              placeholder="Введите Ваш логин"
              id="username"
            />
          </div>
          <div class="form-group">
            <label for="password" class="sr-only">Пароль</label>
            <input
              type="password"
              formControlName="password"
              class="form-control form-control-lg"
              placeholder="Введите Ваш пароль"
              id="password"
            />
          </div>
          <!-- Submit -->
          <button
            [disabled]="isLoading"
            (mousemove)="allService.effectMouseMove($event)"
            class="effectMouse effect-white btn btn-lg btn-block btn-primary d-flex align-items-center"
            type="submit"
          >
            Войти
            <i-feather [style.margin-top.px]="-5" name="log-in" class="ml-auto icon-md align-middle"></i-feather>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
